import React from 'react';
import * as Styles from 'pages/function2/styles';
import coinplug_logo from 'assets/coinplug-logo-horizo.png';
import config from '../../config';
import authRequest from '../../service/authRequest';

const serviceId = config.mykeepin.serviceId;
const type = config.mykeepin.authType.function2;
const redirectUri = config.mykeepin.redirectUri.function2;

// Page function2 (페이지명은 function2 에서 추후에 바뀔 수 있음)
class function2 extends React.Component {
  // Render
  render() {
    return (
      <Styles.PageLayout>
        <Styles.GridLayout>
          {/* 최상단 coinplug logo */}
          <Styles.LogoContainer>
            <Styles.Logo src={coinplug_logo} alt="coinplug-logo" />
          </Styles.LogoContainer>
          {/* 상단 페이지 제목 */}
          <Styles.PageTitle>
            VP SAMPLE
          </Styles.PageTitle>
          {/* 샘플 텍스트 */}
          <Styles.Paragraph>
            Metadium DID 기반 인증 서비스를 테스트합니다. 본 테스트는 VP를 요청하는 Type을 사용하기 때문에, 인증한 유저에게 개인정보를 받아옵니다. 인증 Code 값을 검증하면 인증한 유저의 DID, Signature, 그리고 사전에 등록된 Pubkey 로 암호화된 VP를 받습니다.
          </Styles.Paragraph>
          {/* 로그인 버튼 */}
          <Styles.LoginButtonContainer>
            <Styles.LoginButtonWrapper>
              <Styles.LoginButton onClick={this.onClickLoginButton}> Login </Styles.LoginButton>
            </Styles.LoginButtonWrapper>
          </Styles.LoginButtonContainer>
        </Styles.GridLayout>
      </Styles.PageLayout>
    )
  }

  // On click login button
  onClickLoginButton = async () => {
    // 인증 요청 URI 로 리다이렉트
    const authRequestUri = authRequest({ serviceId, redirectUri, type });
    window.location.assign(authRequestUri);
  }
}

export default function2;